export const GradientLight = () => {
  return (
    <div className="absolute -z-[5] top-0 left-1/3 w-full rounded-full blur-xl aspect-square bg-gradient-to-r from-[#28206C] to-[#28206C]/10 to-70% pointer-events-none" />
  );
};
